import React, { useState } from "react";
import ModalEditarUsuario from "./ModalEditarUsuario";
import "../styles.css";
import { toast } from "react-toastify";

export default function ListaUsuarios({
  visible,
  onClose,
  usuarios,
  onEliminar,
  onActualizar,
  usuario,
}) {
  const [usuarioEditar, setUsuarioEditar] = useState(null);
  const esAdmin = usuario?.rol === "admin";

  if (!visible) return null;

  const handleEditarClick = (u) => {
    setUsuarioEditar(u);
  };

  const handleCerrarModalEditar = () => {
    setUsuarioEditar(null);
  };

    const handleGuardarCambios = async ({ username, password, rol }) => {
    if (!usuarioEditar) return;
    
    const payload = {
        id: usuarioEditar.id,
        username: username || usuarioEditar.username,
        password,
        rol,
    };
    
    await onActualizar(payload);
    handleCerrarModalEditar();
    };

  const handleEliminarClick = (u) => {
    if (!esAdmin) {
      toast.warn("Solo administradores pueden eliminar usuarios");
      return;
    }
    if (window.confirm(`¿Eliminar usuario ${u.username}?`)) {
      onEliminar(u.username);
    }
  };

  return (
    <>
      <div className="modal-overlay">
        <div className="modal modal-ancho">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <h2>Gestión de Usuarios</h2>
            <button
              className="modal-close-btn"
              onClick={onClose}
            >
              ×
            </button>
          </div>

          <div className="tabla-container">
            <table className="tabla-usuarios">
              <thead>
                <tr>
                  <th>Username</th>
                  <th>Rol</th>
                  <th>Fecha de creación</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {usuarios.map((u) => (
                  <tr key={u.username}>
                    <td>{u.username}</td>
                    <td>
                      <span
                        style={{
                          display: "inline-block",
                          padding: "4px 8px",
                          borderRadius: "12px",
                          fontSize: "12px",
                          fontWeight: "500",
                          backgroundColor:
                            u.rol === "admin" ? "#fef3c7" : "#d1fae5",
                          color: u.rol === "admin" ? "#92400e" : "#065f46",
                        }}
                      >
                        {u.rol}
                      </span>
                    </td>
                    <td>{u.fecha_creacion || "—"}</td>
                    <td>
                      <div className="acciones-tabla">
                        <button
                          type="button"
                          className={`botonAccion botonAzul ${
                            !esAdmin ? "disabled" : ""
                          }`}
                          onClick={() => handleEditarClick(u)}
                          disabled={!esAdmin}
                        >
                          Editar
                        </button>
                        <button
                          type="button"
                          className={`botonAccion botonRojo ${
                            !esAdmin ? "disabled" : ""
                          }`}
                          onClick={() => handleEliminarClick(u)}
                          disabled={!esAdmin}
                        >
                          Eliminar
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {usuarioEditar && (
        <ModalEditarUsuario
          visible={!!usuarioEditar}
          usuario={usuarioEditar}
          onClose={handleCerrarModalEditar}
          onGuardar={handleGuardarCambios}
        />
      )}
    </>
  );
}
